/** Memory in the units a person says it in: 16 GB, not 17179869184. */
export function formatMemory(bytes: number | null): string {
  if (bytes === null || bytes <= 0) return '—';
  const gb = bytes / 1024 / 1024 / 1024;
  return `${Number.isInteger(gb) ? gb : gb.toFixed(1)} GB`;
}

export interface ArcBadge { text: string; tone: 'ok' | 'warn' }

/**
 * The short labels shown under an Arc server's name. "Sensor deployed" is the Defender extension being on the
 * machine, never "protected" or "healthy": that is the Defender portal's to say. A server that has left Arc, or
 * whose Arc connection is not Connected, gets an amber label so a gap is visible without opening the tab.
 */
export function arcBadges(arc: { IsPresent: boolean; ArcStatus: string | null; DefenderInstalled: boolean }): ArcBadge[] {
  const badges: ArcBadge[] = [];
  if (!arc.IsPresent) {
    badges.push({ text: 'No longer in Azure Arc', tone: 'warn' });
    return badges;
  }
  badges.push(arc.DefenderInstalled
    ? { text: 'Defender sensor deployed', tone: 'ok' }
    : { text: 'No Defender sensor', tone: 'warn' });
  if (arc.ArcStatus && arc.ArcStatus.toLowerCase() !== 'connected') {
    badges.push({ text: `Arc: ${arc.ArcStatus}`, tone: 'warn' });
  }
  return badges;
}
